import { useEffect } from "react";
import { Theme } from "@/enums/Theme";
import { useUiStore } from "@/stores/ui";

/**
 * Writes the store's theme and skin onto the document element.
 *
 * The stylesheet reads `data-theme` and `data-skin`; the `dark` class exists because
 * shadcn's registry components carry `dark:` utilities. `data-theme-switching` suppresses
 * transitions for one frame, otherwise every themed property animates to its new value at
 * once.
 */
export function useThemeAttributes() {
  const theme = useUiStore((state) => state.theme);
  const skin = useUiStore((state) => state.skin);

  useEffect(() => {
    const root = document.documentElement;

    root.dataset.themeSwitching = "";
    root.dataset.theme = theme;
    root.dataset.skin = skin;
    root.classList.toggle("dark", theme === Theme.Dark);

    const frame = requestAnimationFrame(() => {
      delete root.dataset.themeSwitching;
    });

    return () => cancelAnimationFrame(frame);
  }, [theme, skin]);
}
